import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useAvailableRangesView } from '../context/AvailableRangesViewContext';

const AvailableRangeViewCollapsedTable: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAvailableRangesView();

  return (
    <table
      className={`table ${data.expandView ? 'mb-2' : 'mb-0'}`}
      id="available-ranges-table"
    >
      <thead>
        <tr className="tb-tnx-head">
          <th className="text-left" colSpan={2}>
            <span>{t('AvailableRanges')}</span>
          </th>
          <th className="col-2 text-right">
            <button
              type="button"
              className="badge btn-primary"
              onClick={actions.handleChangeExpandView}
            >
              <em className={`icon ni ni-chevron-${data.expandDirection}`} />
            </button>
          </th>
        </tr>
      </thead>
    </table>
  );
};

export default AvailableRangeViewCollapsedTable;
